export default {
  path: '/projects',
  name: 'projects-list-parent',
  component: () => import(/* webpackChunkName: "projects" */ '@/views/EmptyRouterPage.vue'),
  redirect: {
    name: 'projects',
  },
  children: [
    {
      path: '',
      name: 'projects',
      component: () => import(/* webpackChunkName: "projects" */ './ProjectsListPage.vue'),

    },
    {
      path: 'add',
      name: 'add-project',
      component: () => import(/* webpackChunkName: "projects" */ './ProjectsListPage.vue'),
      meta: {
        openDialog: true,
      },
    },
    {
      path: 'edit/:projectId',
      name: 'edit-project',
      component: () => import(/* webpackChunkName: "projects" */ './ProjectsListPage.vue'),
      meta: {
        openDialog: true,
      },
    },
    {
      path: '*',
      redirect: {
        name: 'projects',
      },
    },
  ],
};
